import { render, staticRenderFns } from "./Remarks.vue?vue&type=template&id=301694f6&scoped=true&"
import script from "./Remarks.vue?vue&type=script&lang=js&"
export * from "./Remarks.vue?vue&type=script&lang=js&"
import style0 from "./Remarks.vue?vue&type=style&index=0&id=301694f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301694f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VSelect,VSpacer,VTextarea})
